const styles = {
  container: {
    height: '100%',
  },
  gridItem: {
    width: '100%',
  },
  assignmentList: {
    padding: '8px',
    height: 'calc(100% - 51px)',
    overflow: 'auto',
  },
};

export default styles;
